import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { unAuthApiService } from "../../../api/api";
import { useAuth } from "../../../providers/AuthProvider";
import { InputEnum } from "../../../types/input.type";
import { validationMessage } from "../../../utils/translation";
import { validatePassword } from "../../../utils/validation/password";
import AuthTitle from "../../AuthTitle/AuthTitle";
import BlueButton from "../../buttons/BlueButton/BlueButton";
import LoginInput from "../../inputs/LoginInput/LoginInput";
import TextWithLink from "../../links/TextWithLink/TextWithLink";
import styles from "./styles.module.scss";

const SignupCreatePassword: React.FC = () => {
  const location = useLocation();
  const [password, setPassword] = useState<string>("");
  const [errorPasswordMessage, setErrorPasswordMessage] = useState<string>("");

  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [errorConfirmPasswordMessage, setErrorConfirmPasswordMessage] =
    useState<string>("");

  const navigation = useNavigate();
  const auth = useAuth();

  const { code } = location.state;

  if (!code) {
    navigation("/login");
  }

  useEffect(() => {
    setErrorPasswordMessage("");
    setErrorConfirmPasswordMessage("");
  }, [password, confirmPassword]);

  const onChangePassword = (value: string) => {
    setPassword(value);
  };

  const onChangeConfirmPassword = (value: string) => {
    setConfirmPassword(value);
  };

  const createPassword = async () => {
    try {
      return await unAuthApiService.createNewPassword(
        password,
        confirmPassword,
        code
      );
    } catch (err: any) {
      toast.error(err.message);
      console.error(err);
    }
  };

  const onPressApply = async () => {
    const validConfirmPassword = await validatePassword(confirmPassword);
    const validPassword = await validatePassword(password);

    if (!validPassword || !validConfirmPassword) {
      validPassword.error && setErrorPasswordMessage(validPassword.error);
      validConfirmPassword.error &&
        setErrorConfirmPasswordMessage(validConfirmPassword.error);
      return;
    }
    if (password !== confirmPassword) {
      setErrorPasswordMessage(validationMessage.passwordsMustBeSame);
      setErrorConfirmPasswordMessage(validationMessage.passwordsMustBeSame);
      return;
    }

    //   AXIOS

    const response = await createPassword();

    if (!response) {
      return;
    }

    navigation("/login");
  };

  return (
    <div className={styles.container}>
      <AuthTitle
        title="Реєстрація"
        subTitle="Код підтверджено успішно! Створіть свій пароль для профілю, щоб завершити реєстрацію."
      />
      <div className={styles.inputsContainer}>
        <LoginInput
          name="Password"
          isRequired
          type={InputEnum.PASSWORD}
          value={password}
          onChange={onChangePassword}
          errorMessage={errorPasswordMessage}
        />
        <div className={styles.passwordContainer}>
          <LoginInput
            name="Confirm Password"
            isRequired
            type={InputEnum.PASSWORD}
            value={confirmPassword}
            onChange={onChangeConfirmPassword}
            errorMessage={errorConfirmPasswordMessage}
          />
        </div>
        <div className={styles.buttonsContainer}>
          <BlueButton
            title="Зареєструватися"
            onClick={onPressApply}
            disabled={confirmPassword.length < 3 || password.length < 3}
          />
          <TextWithLink
            text="Вже маєте обліковий запис? "
            linkText="Вхід"
            to="/login"
          />
        </div>
      </div>
    </div>
  );
};

export default SignupCreatePassword;
